import { ILangText } from "../ILangText";


const labels:{ [k:string]:ILangText } = {
	"tag":{
		en:"Tag",
		is:"Tag"
	},
	"tags":{
		en:"Tags",
		is:"Tög"
	},
	"newTag":{
		en:"New Tag",
		is:"Nýtt tag"
	},
};

const actions:{ [k:string]:ILangText } = {
	"renameTag":{
		en:"Rename Tag",
		is:"Endurnefna tag"
	},
	"setTagColor":{
		en:"Set Tag Color",
		is:"Seta lit tags"
	},
	"deleteTag":{
		en:"Delete Tag",
		is:"Eyða tagi"
	},
	"removeTag":{
		en:"Remove Tag",
		is:"Fjarlæga tag"
	},
};

const messages:{ [k:string]:ILangText } = {

};




const tags:{ [k:string]:ILangText }  = {};
Object.keys(labels).forEach(k => tags[`tags.label.${k}`] = labels[k]);
Object.keys(actions).forEach(k => tags[`tags.action.${k}`] = actions[k]);
Object.keys(messages).forEach(k => tags[`tags.message.${k}`] = messages[k]);
export { tags };